// last-transactions.tsx
import type React from "react";
import "./last-transactions.css";
import { ArrowDownIcon } from "../../../assets/svgs/last-transactions/leaseIcon";
import SimpleOutlineButton from "../../buttons/Simple-Outline-button";
import { useNavigate } from "react-router-dom";
import { EntityType } from "@propertelligent/client-api";
import SimpleSpinner from "../../../components/loader";
import EmptyState from "../../../newComponents/emptystate";
import analyticsIcon from "../../../assets/analyticsIcon.svg";
import { GetImages } from "../../../utils/GetImages";
import UtilHelper from "../../../utils/UtilHelper";
import CurrencyTooltip from "../../../components/currencytooltip/CurrencyTooltip";
import TruncatedDescriptionCell from "../../common/TruncatedDescriptionCell";

interface Transaction {
  id: string;
  type: string;
  person: string;
  unit: string;
  amount: string | number;
  amountRaw?: string;
  date: string;
}

interface LastTransactionsProps {
  transactions: Transaction[];
  entityId?: EntityType;
  isLoading?: boolean;
  onAddPayment?: () => void; // Added callback prop
}

const LastTransactions: React.FC<LastTransactionsProps> = ({
  transactions,
  entityId,
  isLoading = false,
  onAddPayment, // Destructure the new prop
}) => {

  const navigate = useNavigate();

  const handleAddPayment = () => {
    if (onAddPayment) {
      onAddPayment(); // Trigger the modal in parent
    } else {
      // Fallback to navigation if no callback provided
      navigate("/payment/create", {
        state: { isPropertyProp: true, PropertyIdProp: entityId },
      });
    }
  };

  return (
    <div className="last-transactions">
      <div className="last-transactions-header">
        <h2 className="last-transactions-title">Last 5 Transactions</h2>
        <SimpleOutlineButton
          type="button"
          label={"Add Payment"}
          onClick={handleAddPayment}
        />
      </div>

      <div className="transactions-list">

        {/* 🔁 Show Spinner if loading */}
        {isLoading ? (
          <div className="loading-spinner text-center py-4">
            <SimpleSpinner myClassName="Icon50 mt-4" />
          </div>
        ) : transactions.length === 0 ? (
          <EmptyState
            icon={GetImages.emptyStateData}
            className="w-100"
            isBorder={false}
            heading="No Data Found"
            isButton={false}
          />
        ) : (
          transactions.map((transaction) => (
            <div key={transaction.id} className="transaction-item">
              <div className="transaction-icon">
                <ArrowDownIcon fill="var(--color-success)" />
              </div>
              <div className="transaction-details">
                <TruncatedDescriptionCell className="transaction-type" description={transaction.type} noWrap={false} />
                <div className="transaction-person">
                  {transaction.person} {/* - {transaction.unit} */}
                </div>
              </div>
              <div className="transaction-amount-container">
                <div className="transaction-amount">
                  <CurrencyTooltip
                    content={transaction.amountRaw}
                    formatted={transaction.amount}
                  >
                    <span>{transaction.amount || "-"}</span>
                  </CurrencyTooltip>
                </div>
                <div className="transaction-date">{transaction.date}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LastTransactions;